import React, { useMemo } from "react"

export default function CompareStrip({ products = [], onRemove, onClear }) {
  const stats = useMemo(() => {
    if (!products || !products.length) return null
    const minPrice = Math.min(...products.map((p) => Number(p.price) || 0))
    const nearest = products
      .filter((p) => typeof p.__distanceKm === "number")
      .sort((a, b) => a.__distanceKm - b.__distanceKm)[0]
    return { minPrice, nearest }
  }, [products])

  return (
    <div className="mt-8 bg-white border rounded-xl p-4 shadow-sm">
      <div className="text-sm text-gray-600 mb-2">Comparador</div>
      {!products || products.length === 0 ? (
        <div className="text-sm text-gray-500">
          El comparador está vacío. Añade productos con "Agregar al Comparador".
        </div>
      ) : (
        <>
          <div className="flex flex-wrap gap-2">
            {products.slice(0, 12).map((p) => (
              <div
                key={p.id}
                className="flex items-center gap-2 px-3 py-1 rounded border bg-white"
              >
                <span className="text-sm">
                  {p.name}{" "}
                  {typeof p.price === "number"
                    ? `($${p.price.toFixed(0)})`
                    : ""}
                </span>
                <button
                  onClick={() => onRemove?.(p.id)}
                  className="ml-2 text-xs px-2 py-0.5 border rounded text-red-600"
                >
                  Eliminar
                </button>
              </div>
            ))}
          </div>
          {stats && (
            <div className="mt-3 text-sm">
              <div>
                💸 Mejor precio: <strong>${stats.minPrice.toFixed(2)}</strong>
              </div>
              {stats.nearest && (
                <div>
                  📍 Más cercano: <strong>{stats.nearest.name}</strong> (
                  {stats.nearest.__distanceKm?.toFixed(1)} km)
                </div>
              )}
            </div>
          )}
          <div className="mt-3">
            <button
              onClick={() => onClear?.()}
              className="px-3 py-1 rounded border bg-white text-sm"
            >
              Limpiar comparador
            </button>
          </div>
        </>
      )}
    </div>
  )
}
